import styled from 'styled-components';
import { colors, spacer, fontType, snippet } from 'settings/style';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  flex: 1;
  align-self: stretch;
  section {
    margin: ${spacer.xl} 0;
    form {
      max-width: 400px;
    }
  }
`;

export const StyledTitle = styled.span`
  color: ${colors.font};
  margin-bottom: ${spacer.xl};
  ${fontType.lg}
  ${snippet.underline()}
`;
